// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */
import type { IUsersSessionRequest, TUsersSessionModel, IMappers, TUsersSessionResponse } from './types';
import type { IHttpApi, IHttpApiFetchConfig, FetchResponse } from '@cian/http-api';
import type { IUserSessionTokenWebSchema } from '../../../entities/user/UserSessionTokenWebSchema';
import type { IErrorResponseSchema } from '../../../entities/schemas/ErrorResponseSchema';

export function createUsersSessionModel(parameters: IUsersSessionRequest): TUsersSessionModel {
  return {
    v: 1,
    apiType: 'public',
    method: 'GET',
    microserviceName: 'chats',
    pathApi: '/v1/users/session/',
    response: {
      200: {
        contentType: 'json',
      },
      400: {
        contentType: 'json',
      },
    },
    request: {
      parameters,
    },
  };
}

export interface IUsersSessionOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
  parameters: IUsersSessionRequest;
}

export async function fetchUsersSession<TResponse200, TResponse400>({
  httpApi,
  config,
  mappers,
  parameters,
}: IUsersSessionOptions<TResponse200, TResponse400>): Promise<
  FetchResponse<TUsersSessionResponse> | TResponse200 | TResponse400
> {
  const { statusCode, response, headers } = (await httpApi.fetch(
    createUsersSessionModel(parameters),
    config,
  )) as FetchResponse<TUsersSessionResponse>;
  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as IUserSessionTokenWebSchema, headers);
    }
    if (statusCode === 400) {
      return mappers[400](response as IErrorResponseSchema, headers);
    }
  }
  return {
    statusCode,
    response,
    headers,
  } as FetchResponse<TUsersSessionResponse>;
}
